import React from 'react';
import { Layout } from '../components/Layout';
export function NewsletterPage() {
  return <Layout data-id="element-2316">
      <div className="mb-8" data-id="element-2317">
        <h1 className="text-3xl font-bold text-seform-navy" data-id="element-2318">Newsletter</h1>
        <p className="text-slate-500 mt-1" data-id="element-2319">
          Gestione newsletter e comunicazioni.
        </p>
      </div>
    </Layout>;
}